import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import { Divider } from "@mui/material";
import { getBirthDay, getGenderByNumber } from "../utils/constant";
import { TInfoAccount } from "../utils/types";

const listUserInfo = (infoAccount) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const intl = useIntl();
  return [
    {
      intlId: "account.inSchool",
      value: infoAccount?.school
    },
    {
      intlId: "account.comeIn",
      value: infoAccount?.district
        ? `${infoAccount?.district},${infoAccount?.city}`
        : infoAccount?.city || null
    },
    {
      intlId: "Account.gender",
      value: getGenderByNumber(Number(infoAccount?.gender))
    },
    {
      intlId: "account.birthday",
      value: infoAccount?.birthday ? getBirthDay(infoAccount?.birthday) : undefined
    },
    {
      intlId: "account.dayJoin",
      value: moment.unix(infoAccount?.created_at).format("DD/MM/YYYY")
    },
    {
      intlId: "account.achievement",
      value: `${infoAccount?.num_of_achievement_member}/${infoAccount?.total_achievement}`
    },
    {
      intlId: "account.number.vote",
      value: infoAccount?.num_of_vote
    },
    {
      intlId: "account.number.tick",
      value: infoAccount?.num_of_accept
    },
    {
      intlId: "account.number.compat.top",
      value: intl.formatMessage(
        { id: "account.CompatAnswer.value" },
        {
          week: infoAccount?.arena_top?.num_of_top_week || 0,
          month: infoAccount?.arena_top?.num_of_top_month || 0
        }
      )
    },
    {
      intlId: "account.number.top.answer",
      value: intl.formatMessage(
        { id: "account.CompatAnswer.value" },
        {
          week: infoAccount?.ask_top?.num_of_top_week || 0,
          month: infoAccount?.ask_top?.num_of_top_month || 0
        }
      )
    }
  ];
};

const InfoAccountDetail = ({ infoAccount }: { infoAccount: TInfoAccount }) => {
  const listUserInfoShow = listUserInfo(infoAccount)?.filter((e) => !!e?.value);
  return (
    <div className="w-full flex flex-col text-blackQuiz text-[15px] font-normal mb-2">
      {listUserInfoShow?.map((item, index) => (
        <div key={item.intlId}>
          <div className="w-full flex">
            <span className="sm:w-[120px] md:w-[150px]">
              <FormattedMessage id={item.intlId} />
            </span>
            <span className="sm:w-[calc(100%-120px)] md:w-[calc(100%-150px)]">
              {item.value}
            </span>
          </div>
          {index + 1 !== listUserInfoShow?.length && <Divider sx={{ my: 2 }} />}
        </div>
      ))}
    </div>
  );
};
export default InfoAccountDetail;
